import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { toJS } from 'mobx';
import util from 'preact-util';
import { Text, Localizer } from 'preact-i18n';
import linkstate from 'linkstate';

import Input from '../../components/form/input';

function findAllKeys(list) {
    if (!Array.isArray(list) || list.length === 0) {
        return [];
    }

    const allKeys = list.reduce((keySet, item) => {
        // Add each key from the item to the set
        Object.keys(item).forEach(key => keySet.add(key));
        return keySet;
    }, new Set());

    return Array.from(allKeys); // Convert the set of keys back into an array
}

@observer
class AddArrayObject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            foundList: [],
            activeHelpField: null,
            isSearching: false,
        };
    }

    toggleHelpTooltip = (e, fieldName) => {
        e.preventDefault();
        e.stopPropagation();
        const { activeHelpField } = this.state;
        this.setState({ activeHelpField: activeHelpField === fieldName ? null : fieldName });
    }

    onInput = e => {
        const { holdingStore } = this.props;
        const { newObject } = holdingStore;
        const { name, value } = e.target;
        holdingStore.updateObjectKeyValue('newObject', name, value);
    }

    addNew = () => {
        // const { newObject } = this.state;
        const { holdingStore } = this.props;
        const { newObject } = holdingStore;
        // const newObjectCombined = { ...newObject, ...newObjectStore };
        const {
            after = () => {},
            drawerLevel,
        } = this.props;
        const { appState } = this.props.stores;
        after(newObject);
        this.setState({ newObject: {} });
        holdingStore.updateKeyValue('newObject', {});
        appState.toggleDrawer(false, drawerLevel);
    };

    selectElement = (e) => {
        const { holdingStore } = this.props;
        const { newObject } = holdingStore;
        const resultObject = { ...newObject };
        const { foundList } = this.state;
        const { idx } = e.target.closest('.similar-item').dataset;
        const element = foundList[idx];
        if (element) {
            const keys = Object.keys(element);
            keys.forEach((key) => {
                resultObject[key] = element[key];
            });
            holdingStore.updateKeyValue('newObject', resultObject);
            this.setState({
                search: '',
                foundList: [],
            });
        }
    }

    searchInput = async (e) => {
        const search = e.target.value;
        const { newObject } = this.state;
        const {
            fieldObject,
            holdingStore,
            lookupArray,
        } = this.props;

        // Check if we have an async search method defined
        const searchMethod = fieldObject?.searchMethod;
        if (searchMethod && typeof holdingStore[searchMethod] === 'function') {
            this.setState({ search, isSearching: true });
            // Debounce the search
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(async () => {
                const results = await holdingStore[searchMethod](search);
                const foundListKeys = results.length > 0 ? findAllKeys(results) : [];
                this.setState({ foundList: results, foundListKeys, isSearching: false });
            }, 300);
            return;
        }

        const listName = lookupArray || fieldObject.lookupArray;
        let foundListKeys = [];
        let foundList = [];
        if (listName) {
            const list = holdingStore[listName];
            // console.log('searchInput', { search, listName, list })
            if (list) {
                foundListKeys = list[0] ? findAllKeys(list) : [];
            }
            const matchKeys = (item, regExp) => {
                return foundListKeys.some((key) => {
                    // console.log('key', key, item[key], regExp.test(item[key]));
                    if (regExp.test(item[key])) {
                        return true;
                    }
                });
            };
            // console.log({ foundListKeys });
            if (list && search) {
                const regExp = new RegExp(search, 'i');
                foundList = list.filter(item => matchKeys(item, regExp)).map(item => {
                    return item;
                });
            }
        }
        // console.log('foundList', foundList)
        this.setState({ search, foundList, foundListKeys });
    }

    render() {
        const { search, foundList, foundListKeys, activeHelpField } = this.state;
        const {
            before = () => {},
            after = () => {},
            isNew,
            field,
            fieldObject,
            type,
            min,
            maxValue,
            step,
            elementtype,
            datalist,
            datalistHelp,
            datalistValues,
            object,
            holdingStore,
            lookupArray,
        } = this.props;

        const { newObject, adminMembers } = holdingStore;

        const newValue = parseInt(newObject[field] || newObject.id, 10);
        const listName = fieldObject?.lookupArray;
        const searchMethod = fieldObject?.searchMethod;
        const hasSearch = listName || searchMethod;
        let found;
        let foundValue;
        if (listName) {
            const list = holdingStore[listName];
            // console.log('list', list);
            if (list) {
                found = list.find((item) => item.id === newValue);
                foundValue = fieldObject.displayValue && found ? fieldObject.displayValue(found) : JSON.stringify(found, null, 2);
            }
        }

        const { userStore } = this.props.stores;
        const { user } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');
        const { isSearching } = this.state;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 20px;'>

                    <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                        <Text id='form.add'>Add</Text> {field}
                    </div>
                    {/* lookupArray: {lookupArray} */}
                    {/* <xmp>{JSON.stringify(adminMembers, null, 4)}</xmp> */}

                    <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                        {hasSearch && <div class='w-100 mb-3'>
                            <div class='position-relative'>
                                <input
                                    class='inputForm form-control form-control-lg py-0 w-100'
                                    type='text'
                                    placeholder={'Search by name or cellphone...'}
                                    onInput={this.searchInput}
                                    value={search}
                                />
                                {isSearching && (
                                    <div class='position-absolute' style='right: 10px; top: 50%; transform: translateY(-50%);'>
                                        <div class='spinner-border spinner-border-sm text-primary' role='status'>
                                            <span class='visually-hidden'>Searching...</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>}
                    </div>

                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(datalist, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(holdingStore, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(search, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(foundList, null, 4)}</xmp> */}
                    {/* // <xmp>{JSON.stringify(newObject, null, 4)}</xmp> // */}
                    {/* fieldObject: <xmp>{JSON.stringify(fieldObject, null, 4)}</xmp> */}
                    {foundList && foundList.length > 0 && <>
                        <div class='font-weight-lighter px-3 py-1 text-muted' >
                            <small class='text-uppercase'>
                                <Text id='form.search-result'>Search results</Text>
                            </small>
                        </div>
                        <div class={`d-flex flex-column mx-3 mb-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                            {foundList.map((el, idx) => {
                                // Use datalist fields if available, otherwise filter to only show string/number fields
                                const displayKeys = datalist && datalist.length > 0
                                    ? datalist
                                    : (foundListKeys || []).filter(key => {
                                        const val = el[key];
                                        return val !== null && val !== undefined && (typeof val === 'string' || typeof val === 'number');
                                    });
                                return (
                                    <div
                                        class='d-flex flex-row justify-content-between align-items-center similar-item'
                                        data-idx={idx}
                                        onClick={this.selectElement}
                                        style='cursor: pointer;'
                                    >
                                        {displayKeys.map(field => {
                                            const val = el[field];
                                            if (val === null || val === undefined || typeof val === 'object') return null;
                                            return (
                                                <div class='flex-fill py-2 px-3'>
                                                    <span class='font-weight-lighter text-muted'>{field}:</span> {val}
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    </>}

                    <div class={`compact-form-container mx-3 rounded-lg ${darkmode ? 'bg-darkmode darkmode' : 'bg-lightmode'}`}>
                        <div class='compact-field-table'>
                            {datalist && datalist.length > 0 ? datalist.map((el, idx) => {
                                const help = datalistHelp && datalistHelp[el] ? datalistHelp[el] : '';
                                return (
                                    <div class='compact-field-row'>
                                        <div class='compact-field-label-cell' style='width: 140px; max-width: 140px; min-width: 140px;'>
                                            <div class='compact-field-label-content'>
                                                {el}
                                                {help && (
                                                    <span
                                                        class={`compact-help-icon ${activeHelpField === el ? 'active' : ''}`}
                                                        onClick={(e) => this.toggleHelpTooltip(e, el)}
                                                    >
                                                        <i class='fa-solid fa-circle-info' style='font-size: 10px;' />
                                                        <span class={`compact-help-tooltip ${activeHelpField === el ? 'show' : ''}`}>
                                                            {help}
                                                            <button
                                                                class='compact-help-close'
                                                                onClick={(e) => { e.stopPropagation(); this.setState({ activeHelpField: null }); }}
                                                            >
                                                                <i class='fa-solid fa-times' />
                                                            </button>
                                                        </span>
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div class='compact-field-input-cell'>
                                            <div class='compact-input-wrapper'>
                                                <Input
                                                    stores={this.props.stores}
                                                    holdingStore={holdingStore}
                                                    objectName={'newObject'}
                                                    object={newObject}
                                                    type={el === 'image' ? 'image' : (el === 'json' ? 'textarea' : 'text')}
                                                    field={el}
                                                    min={min}
                                                    max={maxValue}
                                                    step={step}
                                                    name={field}
                                                    value={newObject[el]}
                                                    title={''}
                                                    placeholder={el}
                                                    onInput={this.onInput}
                                                    classNames='compact-input'
                                                    skipSurroundingDivs={true}
                                                    usefulValues={datalistValues && datalistValues[idx] ? datalistValues[idx] : []}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            }) : <>
                                <div class='compact-field-row'>
                                    <div class='compact-field-label-cell' style='width: 140px; max-width: 140px; min-width: 140px;'>
                                        <div class='compact-field-label-content'>{field}</div>
                                    </div>
                                    <div class='compact-field-input-cell'>
                                        <div class='compact-input-wrapper'>
                                            <Input
                                                stores={this.props.stores}
                                                holdingStore={holdingStore}
                                                objectName={'newObject'}
                                                object={newObject}
                                                type={field === 'image' ? 'image' : (field === 'json' ? 'textarea' : 'text')}
                                                field={field}
                                                min={min}
                                                max={maxValue}
                                                step={step}
                                                name={field}
                                                value={newObject[field]}
                                                title={''}
                                                placeholder={field}
                                                onInput={this.onInput}
                                                classNames='compact-input'
                                                skipSurroundingDivs={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>}
                        </div>
                    </div>

                    <div class={`w-100 ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} d-flex flex-column justify-content-start py-3 px-3`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.addNew}><Text id='form.add'>Add</Text> {field}</button>
                    </div>
                </div>
            </div>
        </>);
    }
}

export default AddArrayObject;
